import { Image } from 'expo-image';
import { FlatList, Pressable, StyleSheet, View } from 'react-native';

import { ChallengeHomeCardProps } from './types';

function renderItem({ item }: { item: ChallengeHomeCardProps['challenges'][number] }) {
  return (
    <Pressable style={[styles.container, { width: item.imageWidth }]} onPress={item.onPress}>
      <Image contentFit="cover" source={{ uri: item.image }} style={styles.image} />
    </Pressable>
  );
}

function renderItemSeparator() {
  return <View style={{ width: 16 }} />;
}

export function ChallengeHomeCardMobile(props: ChallengeHomeCardProps) {
  const { challenges, style, testID } = props;

  if (challenges.length === 1) {
    const firstChallenge = challenges[0];

    return (
      <Pressable testID={testID} style={[styles.container, style]} onPress={firstChallenge.onPress}>
        <Image contentFit="cover" source={{ uri: firstChallenge.image }} style={styles.image} />
      </Pressable>
    );
  }
  return (
    <FlatList
      testID={testID}
      horizontal
      style={style}
      showsHorizontalScrollIndicator={false}
      data={challenges}
      ItemSeparatorComponent={renderItemSeparator}
      renderItem={renderItem}
    />
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: 127,
  },
  image: {
    width: '100%',
    height: '100%',
    borderRadius: 8,
  },
});
